import { ArrowUpRight, ShieldCheck } from "lucide-react";
import { PageHeader, Reveal, useSeo } from "@/components/site/Motion";
import { journals, ojs, site } from "@/content/site";

// Accounts live in OJS; these pages hand users off to the secure OJS forms for each journal.
const Handoff = ({ mode }) => {
  const isLogin = mode === "login";
  const path = isLogin ? "/login" : "/user/register";
  useSeo(isLogin ? "Login" : "Register");
  return (
    <div data-testid={`${mode}-page`}>
      <PageHeader eyebrow={isLogin ? "Account" : "Join"} title={isLogin ? "Welcome back." : "Create your account."} intro={isLogin ? "Sign in to manage submissions, reviews and notifications." : "Register with a journal to submit manuscripts and receive new issue notifications."} />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pb-28 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7 space-y-4">
          {journals.map((j, i) => (
            <Reveal key={j.slug} delay={i * 0.08}>
              <a href={ojs(j.slug, path)} className="group flex items-center gap-6 bg-white border border-[var(--line)] p-5 hover:border-[var(--emerald)] transition-colors" data-testid={`${mode}-handoff-${j.slug}`}>
                <img src={j.cover} alt="" className="w-16 aspect-[2/3] object-cover" />
                <span className="flex-1">
                  <span className="block font-mono-x text-xs tracking-[0.18em] uppercase text-[var(--ink-muted)]">{j.abbr}</span>
                  <span className="block font-display text-2xl sm:text-3xl">{isLogin ? "Login to" : "Register with"} {j.title}</span>
                </span>
                <ArrowUpRight className="w-6 h-6 shrink-0 transition-transform group-hover:rotate-45" />
              </a>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15} className="lg:col-span-4 lg:col-start-9">
          <div className="bg-[var(--paper-2)] p-8">
            <ShieldCheck className="w-8 h-8 text-[var(--emerald)] mb-5" strokeWidth={1.4} />
            <p className="font-display text-2xl mb-3">Secure sign-in via Open Journal Systems</p>
            <p className="text-[var(--ink-muted)] leading-relaxed">{site.privacy}</p>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export const Login = () => <Handoff mode="login" />;
export const Register = () => <Handoff mode="register" />;
